<!-- ------------------------------
  Hybread - FooterHubRead.vue

  Mathias BENOIT
  Adam CHABA
  Eva MAROT
  Sacha PORTAL

  This component is the footer.
------------------------------ -->

<template>
  <footer>
    <img src="@/assets/logo_header.svg" />
    <p>© 2024 Mathias BENOIT – Adam CHABA – Eva MAROT – Sacha PORTAL</p>
  </footer>
</template>

<!-- Style of the footer -->
<style scoped>
footer {
  background-color: white;
  height: 100px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: center;
}
footer p {
  font-family: Inter;
  font-size: 0.7em;
  font-weight: 400;
  color: #0a859a;
  margin-bottom: 1em;
}
footer img {
  height: 2em;
  width: auto;
  margin-top: 0.8em;
  margin-bottom: 0.3em;
}
</style>
